import { useState  } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import axios from 'axios';
import API from '../utils/api';
import Alerta from '../Alerta';

function ActualizarFechaPagoModal({modalFecha, setModalFecha, detalle, getPrestamoDetalle }) {
  const [fecha, setFecha] = useState('');
  const [alerta, setAlerta] = useState({})
  const {IdPrestamoDetalle, Cuota, FechaPago} = detalle 



  var url = API.urlAPI + "prestamodetalle/FechaPago/"
  const handleSubmit = async () => {
    const urlFechaPago =  url+ IdPrestamoDetalle



    
    if([fecha].includes('')){
        setAlerta({
               msg: 'Todos los campos son obligatorios',
               error: true
           });
       return
   }
   const fecha1 = new Date(fecha);
   const fecha2 = new Date(FechaPago);

   if(fecha1 < fecha2){

     setAlerta({
               msg: 'La fecha no puede ser menor',
               error: true
           });
       return
   }

    try {
        const { data } =  await axios.put(urlFechaPago, {"FechaVencimiento": fecha })
        console.log(fecha)
        setAlerta({})
        setTimeout(() => {getPrestamoDetalle()}, 500) 
    } catch (error) {
      console.log(error.response.data.msg)
        setAlerta({
            msg: error.response.data.msg,
            error: true
        })
    }
    console.log(fecha)
    console.log(urlFechaPago)
    setModalFecha(false);   
  }
  const { msg } = alerta
  return (
    <>
      

      <Modal show={modalFecha} onHide={() => setModalFecha(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{`Modificar Fecha Vencimiento - Cuota ${Cuota}`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
          {msg && 
            <Alerta alerta={alerta}></Alerta>
        } 
            <Form.Group controlId="fecha">
              <Form.Label>Fecha:</Form.Label>
              <Form.Control type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setModalFecha(false)}>
            Cerrar
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ActualizarFechaPagoModal;
